import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import { formatTimestamp } from "@/utils/datetime";
import { useTenantStore } from "@/store/tenant";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// v0.14.1 hotfix — delegate to the tenant-tz-aware formatter so every
// existing formatDate() call site automatically renders in the tenant's
// configured timezone (default Asia/Kolkata). Reads the tenant tz from
// the Zustand store at call time so it picks up Settings → Timezone
// changes without a reload. Kept as a non-hook standalone function so
// it's safe to call from anywhere (loops, getInitialProps, etc).
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const iso = value instanceof Date ? value.toISOString() : value;
  const tz = useTenantStore.getState().timezone || "Asia/Kolkata";
  return formatTimestamp(iso, "datetime", tz);
}
